import { useQuery } from '@apollo/client';
import uniq from 'lodash/uniq';

import {
  GetProductImagesQuery,
  GetProductImagesQueryVariables,
  ProductIdType,
  WishlistList,
} from '@notino/shared/definitions/types';

import getProductImagesQuery from '../../../queries/getProductsImages.graphql';

type Params = {
  lists: WishlistList[];
  inView: boolean;
};

export const LIST_THUMBNAIL_COUNT = 3;

export const useListThumbnails = ({ lists, inView }: Params) => {
  const idsToFetch = uniq(
    lists.flatMap((list) => list.products.slice(0, LIST_THUMBNAIL_COUNT))
  );

  const { data } = useQuery<
    GetProductImagesQuery,
    GetProductImagesQueryVariables
  >(getProductImagesQuery, {
    skip: idsToFetch.length === 0 || !inView,
    variables: {
      ids: idsToFetch.map(String),
      idType: ProductIdType.Web,
    },
    ssr: false,
  });

  const getThumbnails = (listId: string) => {
    const list = lists.find((l) => l.id === listId);
    if (!list) {
      return [];
    }

    const productIds = list.products.slice(0, LIST_THUMBNAIL_COUNT);

    return (
      data?.vpProductByIds
        .filter((thumb): thumb is NonNullable<typeof thumb> => thumb !== null)
        .filter(({ id }) => productIds.includes(Number(id)))
        .map((thumb) => thumb.imageUrl)
        .filter((url): url is string => url != null) || []
    );
  };

  return {
    getThumbnails,
  };
};
